
export default function QueryResultsPage() {
    return (
        <div className="query-page">
            Underconstruction for future use! 
        </div>
    )
}
